import {Component, OnInit} from '@angular/core';
import {EventService} from "../services/event.service";
import {Event} from "../models/event";
import {Router, RouterLink} from "@angular/router";
import {AuthenticationService} from "../services/authentication.service";
import {CATEGORIES} from "../constants/categories";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {CountToDirective} from "../directives/count-to.directive";
import {FormsModule} from "@angular/forms";
import {EventCardComponent} from "../event-card/event-card.component";
import {EventCardPlaceholderComponent} from "../event-card-placeholder/event-card-placeholder.component";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  imports: [
    CountToDirective,
    FormsModule,
    RouterLink,
    EventCardComponent,
    EventCardPlaceholderComponent,
    NgIf,
    NgForOf
  ],
  standalone: true
})
export class HomeComponent implements OnInit {
  categories = CATEGORIES;

  // Database counters variables
  activity_number: number = 0;
  location_number: number = 0;
  participant_number: number = 0;

  // Events and event filtering variables
  searchTerm: string = '';
  loadingEvents: Boolean = true;
  events!: Event[];

  constructor(
    private eventService: EventService,
    private authService: AuthenticationService,
    private router: Router
  ) {}

  async ngOnInit() {
    await this.eventService.init(4);

    this.events = this.eventService.getEvents();

    await this.eventService.countEvents().then(data => {
      this.activity_number = data.users;
      this.location_number = data.uniqueLocations;
      this.loadingEvents = false;
    })

    await this.authService.countUsers().then(number => {
      this.participant_number = number;
    });
  }

  searchActivities() {
    this.router.navigate(['/activiteiten'], { queryParams: { query: this.searchTerm }, replaceUrl: true});
  }
}
